export default __webpack_public_path__ + "static/artifakt-element-medium-7a7c4bd98a50e1eb962211f8ee451440.ttf";